import fewFilingsIcon from '../../../../../assets/few-stories-icon.svg';
import withComponentName from '../../../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const NoContent = () => (
  <div className={Styles.no_content_row}>
    <div className={Styles.no_content_img}>
      <img src={fewFilingsIcon} alt="story icon" height="42" width="42" />
    </div>
    <div className={Styles.body_content}>
      <div className={Styles.title}>
        No content was found that matches your criteria
      </div>
    </div>
  </div>
);

export default withComponentName(NoContent);
